import { initializeApp } from 'firebase/app';
import { Analytics, getAnalytics, isSupported } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyBKl34iiHbKO03tFDmfjovhMI7IlaD3O6I',
  authDomain: 'aphrodite-attire.firebaseapp.com',
  projectId: 'aphrodite-attire',
  storageBucket: 'aphrodite-attire.firebasestorage.app',
  messagingSenderId: '686266298084',
  appId: '1:686266298084:web:bf4ba003e3deff02f486f1',
  measurementId: 'G-5DZ1HVDS8Q'
};

export const app = initializeApp(firebaseConfig);

export let analytics: Analytics | undefined;

if (typeof window !== 'undefined') {
  void isSupported()
    .then(supported => {
      if (supported) {
        analytics = getAnalytics(app);
      }
    })
    .catch(() => undefined);
}
